import { RadioOptionInput } from '@framework/form/inputs/RadioOptionInput.tsx';
import clx from 'classnames';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { type IWidgetComponentOptionProps } from '../../../../IWidgetType.ts';
import { ParagraphSizeText } from '../../../common/style/ParagraphSizeText.tsx';
import { type IAdvancedSingleSelectWidget } from '../../advanced-single-select/IAdvancedSingleSelectWidget.ts';
import { OptionLabel } from '../../common/option-list/style/OptionLabel.tsx';
import { getWidgetProps } from '../../common/util/getWidgetProps.ts';
import { type ISingleSelectWidget } from '../ISingleSelectWidget.ts';

export interface ISingleSelectOptionProps
  extends IWidgetComponentOptionProps<
    ISingleSelectWidget | IAdvancedSingleSelectWidget
  > {
  groupName: string;
}

export function SingleSelectOption(props: ISingleSelectOptionProps) {
  const { option, hideLabel } = props;

  const widgetOptions = getWidgetProps(props);

  if (!option) return;

  return (
    <RadioOptionInput
      readOnly={widgetOptions.readonly}
      className={clx({ 'hide-label': hideLabel })}
      name={props.groupName}
      optionValue={option.value}
      // Permette al campo di essere deselezionato
      allowUnselect
      disabled={option?.disabled}
    >
      <OptionLabel hideLabel={hideLabel}>
        <ParagraphSizeText>
          <RichTextAdvancedRender hasCustomFont inline text={option.label} />
        </ParagraphSizeText>
      </OptionLabel>
    </RadioOptionInput>
  );
}
